/**
 * @description Encapsulates details of syntax highlighting engine used
 */
;(function () {
  'use strict'

  angular
    .module('contrast.syntax-highlighting')
    .factory('syntaxHighlighter', syntaxHighlighterFactory)

  function syntaxHighlighterFactory(Prism) {
    'ngInject'

    return {
      highlight: highlight
    }

    /**
     * @param {string} str
     * @param {string} language
     * @returns {string}
     */
    function highlight(str, language) {
      /* eslint-disable no-undef */
      language = Prism.languages[language.toLowerCase()]
      return Prism.highlight(str, language)
      /* eslint-enable no-undef */
    }
  }
})()
